module.exports = __webpack_public_path__ + "static/sport/bgi-tag-active.f13c96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-tag-active.png
// module id = KH0Y
// module chunks = 0